import React from 'react'
import { Button, Menu, MenuItem } from 'react-mdl'

const NODE_TYPES = [
  'paragraph',
  'heading_1',
  'heading_2',
  'heading_3',
  'heading_4',
  'heading_5',
  'heading_6',
]

const NODE_NAMES = {
  paragraph: 'Paragraph',
  heading_1: 'Heading 1',
  heading_2: 'Heading 2',
  heading_3: 'Heading 3',
  heading_4: 'Heading 4',
  heading_5: 'Heading 5',
  heading_6: 'Heading 6',
}

export const getCurrentBlockType = state => {
  const node = state.blocks.find(node => NODE_TYPES.includes(node.type))
  return NODE_NAMES[node ? node.type : 'paragraph']
}

const updateState = (state, type) =>
  state
    .transform()
    .setBlock({
      type,
    })
    .focus()
    .apply()

const ParagraphStyleSelector = ({ state, onChange }) => (
  <span style={{ position: 'relative' }}>
    <Button id="paragraph-selector-menu">{getCurrentBlockType(state)}</Button>
    <Menu target="paragraph-selector-menu">
      {NODE_TYPES.map(type => (
        <MenuItem key={type} onClick={() => onChange(updateState(state, type))}>
          {NODE_NAMES[type]}
        </MenuItem>
      ))}
    </Menu>
  </span>
)

const Plugin = () => ({
  schema: {
    nodes: {
      heading_1: ({ children }) => <h1>{children}</h1>,
      heading_2: ({ children }) => <h2>{children}</h2>,
      heading_3: ({ children }) => <h3>{children}</h3>,
      heading_4: ({ children }) => <h4>{children}</h4>,
      heading_5: ({ children }) => <h5>{children}</h5>,
      heading_6: ({ children }) => <h6>{children}</h6>,
    },
  },
})

export { Plugin as ParagraphStyleSelectorPlugin, ParagraphStyleSelector }



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/ParagraphStyleSelector.js